import React, { useState } from "react";
import { API_URL } from "../config/API_URLS.tsx";
import { authenticatedFetch } from "../auth/RequestSigner.tsx";
import ErrorModal from "./ErrorModal.tsx";
import SuccessModal from "./SuccessModal.tsx";
import { useNavigate } from "react-router-dom";

export function RequestProcessModal({ aprendizId, isOpen, onClose }) {
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleProcessStatus = async (statusId) => {
    try {
      setLoading(true);
      const response = await authenticatedFetch(`${API_URL}/v1/aprendiz-change-status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(aprendizId),
          status_id: statusId
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al procesar la solicitud');
      }
      
      // Si la respuesta es exitosa, ocultamos el indicador de carga
      setLoading(false);
      
      // Configurar mensaje de éxito según la acción realizada
      const mensaje = statusId === 2 
        ? "Se ha aceptado la solicitud del aprendiz correctamente" 
        : "Se ha rechazado la solicitud del aprendiz correctamente";

      setSuccessMessage(mensaje);
      setShowSuccess(true);
      
      // Luego mostramos el modal de éxito
   
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage(error.message || 'Error al procesar la solicitud');
      setShowError(true);
      setLoading(false);
    }
  };

  const handleAccept = () => {
    handleProcessStatus(5); // 2 para aceptar
  };

  const handleReject = () => {
    handleProcessStatus(6); // 3 para rechazar
  };

  const handleCloseErrorModal = () => {
    setShowError(false);
  };
  
  const handleCloseSuccessModal = () => {
    setShowSuccess(false);
    // Navegar a la lista de solicitudes después de cerrar el modal de éxito
    navigate('/user-registration-request');
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none" data-testid="request-process-modal">
          <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
          <div className="relative w-auto my-6 mx-auto max-w-sm z-10" data-testid="request-process-modal-container">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" data-testid="request-process-modal-content">
              <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t" data-testid="request-process-modal-header">
                <h3 className="text-2xl font-semibold text-amber-700 text-center" data-testid="request-process-modal-title">
                  Procesar solicitud
                </h3>
                <button
                  className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={onClose}
                  data-testid="request-process-modal-close-button"
                >
                  <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto" data-testid="request-process-modal-body">
                <p className="my-4 text-slate-500 text-lg leading-relaxed" data-testid="request-process-modal-text">
                  ¿Qué deseas hacer con la solicitud del usuario con id {aprendizId}?
                </p>
              </div>
              <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b" data-testid="request-process-modal-footer">
                {loading ? (
                  <div className="flex items-center justify-center w-full">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-amber-700"></div>
                    <span className="ml-3 text-gray-700">Procesando...</span>
                  </div>
                ) : (
                  <>
                    <button
                      className="bg-green-500 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-4 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleAccept}
                      data-testid="request-process-modal-accept-button"
                    >
                      Aceptar
                    </button>
                    <button
                      className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleReject}
                      data-testid="request-process-modal-reject-button"
                    >
                      Rechazar
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
       <SuccessModal 
          isOpen={showSuccess} 
          onClose={handleCloseSuccessModal} 
          message={successMessage} 
      />
      
      <ErrorModal 
        isOpen={showError} 
        onClose={handleCloseErrorModal} 
        message={errorMessage} 
      />
      
   
    </>
  );
}
